/**
 * App root — provides Auth context and renders the router.
 * All routing lives in AppRouter.
 */

import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { UnsavedChangesProvider } from '@/contexts/UnsavedChangesContext';
import AppRouter from '@/router/AppRouter';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UnsavedChangesProvider>
          <AppRouter />
        </UnsavedChangesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
